@import "../../../theme/global";

.circle {
  background-color: $background-color-step-200 !important;
  border-radius: 50%;
  display: inline-block;
  padding: .5rem;
  width: 2rem;
  height: 2rem;
  margin-right: 1rem;
}
.circle lar-icon {
  display: block;
  width: 100%;
  height: 100%;
}
lar-list-item {
  background-color: $background-color-step-100 !important;
  color: $text-color !important;
}
h4 {
  padding: 0; 
  margin: 0;
  white-space: break-spaces;
}
.date, small {
  color: $text-color-step-150 !important;
}
lar-badge {
  margin-top: .2rem;
  margin-right: .3rem;
  font-weight: normal;
}
